import { Divider, Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const RefundsConfigurationSkeleton = () => {
  return (
    <Styles.MainContainer>
      <Skeleton variant="text" width="100%" height={20} />

      <Styles.RefundMethodsList>
        {Array.from({ length: 4 }).map((_, index) => (
          <Styles.RefundMethodRow key={index}>
            <Skeleton variant="rounded" width={24} height={24} />
            <Styles.RefundMethodBox>
              <Skeleton variant="rounded" width="100%" height={72} />
            </Styles.RefundMethodBox>
            <Skeleton variant="rounded" width={48} height={24} />
          </Styles.RefundMethodRow>
        ))}
      </Styles.RefundMethodsList>

      <Skeleton variant="text" width="80%" height={20} />

      <Divider />

      <Styles.Section>
        <Skeleton variant="text" width={220} height={28} />
        <Skeleton variant="text" width="100%" height={20} />
        <Skeleton variant="rounded" width="100%" height={56} />
      </Styles.Section>
    </Styles.MainContainer>
  )
}

export default RefundsConfigurationSkeleton
